// extracted by mini-css-extract-plugin
module.exports =  {"search-bar-container":"search-bar-container-p4tSt","search-input":"search-input-bAgAh","icon":"icon-QOYfJ"};